<template>
  <div class="book-page-container">
    <TopNavbar title="我的动态"></TopNavbar>
    <MomentMine></MomentMine>
  </div>
</template>

<script>
  import TopNavbar from "../../common/TopNavbar";
  import MomentMine from "./MomentMine";
  export default {
    name: "MomentMinePage",
    components: {
      MomentMine,
      TopNavbar,
    },
    mounted() {
    },
    data() {
      return {
      }
    },
    computed: {

    }
  }
</script>

<style lang="scss" scoped>
  .book-page-container {
    padding-top: 54px;
    min-height: 100vh;
  }

  .book-list-container {
    margin-top: 4px;
  }

</style>
